import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: "app-jsignal",
    template: `

          <!-- Deviation Id clickable blue link -->
    <a
  *ngIf="params?.deviationLink"
  [href]="deviationUrl"
  rel="noopener noreferrer"
  (click)="onLinkClick($event)"
  style="
    color:#007bff;
    cursor:pointer;
    text-decoration:underline;
    font-weight:500;
    margin-left:6px;
  "
>
  {{ params.value }}
</a>

<!-- SIGNAL LINK -->
<a
  *ngIf="params?.signalLink"
  (click)="onSignalClick($event)"
  style="
    color:#007bff;
    cursor:pointer;
    text-decoration:underline;
    font-weight:500;
    margin-left:6px;
  "
>
  {{ params.value }}
</a>

<a
  *ngIf="params?.normalLink"
  (click)="onNormalLinkClick($event)"
  style="
    color:#007bff;
    cursor:pointer;
    text-decoration:underline;
    font-weight:500;
    margin-left:6px;
  "
>
  {{ params.value }}
</a>

    

    <div style="display: flex; gap: 4px; align-items: center;">

       <!-- EXPAND / COLLAPSE CHEVRON -->
      <button
       *ngIf="params?.showExpand"
        mat-icon-button
        class="expand-btn"
        (click)="toggleRow($event)"
        [disabled]="params?.node?.data?.__isDetail"
      >
        <mat-icon
          class="chevron-icon"
          [class.expanded]="isExpanded">
          chevron_right
        </mat-icon>
      </button>

      <input
        *ngIf="params?.onCheckboxChange"
        type="checkbox"
        [checked]="params.node.data.isSelected"
        (change)="onCheckboxChange($event)"

        [disabled]="params?.disableCheckBox"

        style="margin-left: 7px; margin-right: 6px; transform: scale(1.2); background:#F4C430"
      />

      <button
        *ngIf="params?.download"
        title="Download"
        (click)="downloadWord($event)"
        class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light"
        style="padding: .3rem .8rem;"
      >
        <i class="fas fa-download"></i>
      </button>

      <button
        *ngIf="params?.onWord"
        title="Download Word"
        class="btn btn-outline"
        style="padding:0.25rem 0.45rem; display:inline-flex; align-items:center; justify-content:center; border-radius:0.2rem;"
        (click)="onWord($event)"
        aria-label="Download Word"
      >
        <i
          class="fas fa-file-word"
          style="font-size:0.95rem; line-height:1; display:inline-block;color:#2B579A;"
        ></i>
      </button>

      <button
        *ngIf="params?.onPdf"
        title="Download PDF"
        class="btn  btn-sm waves-effect waves-light"
        style="padding:0.25rem 0.45rem;"
        (click)="onPdf($event)"
        aria-label="Download PDF"
      >
        <i
          class="fas fa-file-pdf"
          style="font-size:0.95rem; line-height:1; display:inline-block; color:red;"
        ></i>
      </button>

      <button
        *ngIf="params?.onPreview"
        title="Preview"
        class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
        style="padding: .3rem .8rem;background-color: #17a2b8;cursor: pointer;"
        (click)="onPreview($event)"
      >
        <i class="fas fa-eye"></i>
      </button>

      <!-- Review button -->

      <button
        *ngIf="params?.onReview"
        title="Review"
        class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
        style="padding: .3rem .8rem;background-color: #28a745;cursor: pointer;"
        (click)="onReview($event)"
      >
        <i class="fas fa-pen"></i>
      </button>

      <button
        title="Edit"
        *ngIf="!params?.hideEdit && params?.edit"
        
        class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light"
        style="padding: .3rem .8rem"
        [appCriticalOperation]="128"
        [criticalMethod]="edit.bind(this)"
      >
        <i class="fas fa-pencil-alt"></i>
      </button>

        <button
        title="Edit"
        *ngIf="!params?.hideEdit && params?.PopUpEdit"
        (click)="PopUpEdit($event);"
        class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light"
        style="padding: .3rem .8rem"
       
      >
        <i class="fas fa-pencil-alt"></i>
      </button>

      <!-- below button used in Review Activity Screen  -->
      <button
        *ngIf="params?.onAssign"
        title="Self-Assign"
        (click)="onAssign($event)"
        style="padding: .3rem .8rem;background-color: #05339C"
        class="btn btn-outline  btn-rounded btn-sm waves-effect waves-light "
      >
        <i class="fas fa-user-plus"></i>
      </button>

      <button
        *ngIf="params?.onStartReview"
        title="Start Review"
        class="btn btn-outline  btn-rounded btn-sm waves-effect waves-light "
        style="padding: .3rem .8rem;background-color: #41A67E;cursor: pointer;"
        (click)="onStartReview($event)"
      >
        <i class="fas fa-file-signature"></i>
      </button>

        <button
        *ngIf="params?.onSignalCreation"
        title="Create Signal"
        class="btn btn-outline  btn-rounded btn-sm waves-effect waves-light "
        style="padding: .3rem .8rem;background-color: #dbc754ff;cursor: pointer;"
        [appCriticalOperation]="146"
        [criticalMethod]="onSignalCreation.bind(this)"
      >
      <i class="fas fa-notes-medical"></i>

      </button>

      <!-- Deviation button -->
      <button
        *ngIf="params?.onDeviationCreation"
        title="Create Deviation"
        class="btn btn-outline  btn-rounded btn-sm waves-effect waves-light "
        style="padding: .3rem .8rem;background-color: #f79d48ff;cursor: pointer;"
        

        [appCriticalOperation]="147"
        [criticalMethod]="onDeviationCreation.bind(this)"
      >
      <i class="fas fa-random"></i>
      </button>
      
       <button
        *ngIf="params?.delete"
        title="Delete"
       
        [appCriticalOperation]="129"
        [criticalMethod]="delete.bind(this)"
        class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
        style="background:#d71920;padding: .3rem .8rem"
        
      >
        <i class="far fa-trash-alt"></i>
      </button>

       <button
        *ngIf="params?.PopUpDelete"
        title="Delete"
       
        
        (click)="PopUpDelete($event)"
        class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
        style="background:#d71920;padding: .3rem .8rem"
        
      >
        <i class="far fa-trash-alt"></i>
      </button>

      <!-- Regenerate Document Button -->
        <button
          *ngIf="params?.onRegenerateDocument"
          title="Regenerate Document"
          class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"
          style="padding: .3rem .8rem; background-color: #f39c12; cursor: pointer;"
          (click)="onRegenerateDocument($event)"
        >
          <i class="fas fa-sync-alt"></i>
        </button>
  `,
    styles: [` 

  /* ⭐ CHEVRON */
    .expand-btn {
      width: 28px;
      height: 28px;
      padding: 0;
    }

    .chevron-icon {
      font-size: 22px;
      transition: transform 200ms ease;
    }

    .chevron-icon.expanded {
      transform: rotate(90deg);
    }`],
    standalone: false
})
export class JSIGNALBUTTON implements ICellRendererAngularComp {
  params: any;
  label: string;
  permissions: any[] = [];
  isChecked: boolean = false;
   isExpanded = false;
   deviationUrl!: string;

  agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
    this.permissions = this.params.values || [];
    this.isChecked = this.params.node.data.selectinstance || false;
    this.syncExpandedState();

    if (params.getDeviationUrl instanceof Function) {
    this.deviationUrl = params.getDeviationUrl({
      rowData: params.node.data
    });
  }
  }

  refresh(params?: any): boolean {
    this.params = params;
    this.isChecked = this.params.node.data.selectinstance || false;
    this.syncExpandedState();
    return true;
  }

  hasPermission(buttonId: number): boolean {
    // Check if 'screen' exists in the permissions array
    const hasScreen = this.permissions.some(
      (permission) =>
        typeof permission === "string" && permission.includes("screen")
    );

    // If 'screen' is not present, enable all buttons
    if (!hasScreen) {
      return true;
    }

    // Otherwise, check if the specific buttonId is in the permissions list
    return this.permissions.includes(buttonId);
  }

  edit($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params.edit instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.edit(params);
    }
  }
  delete($event) {
    if (this.params.delete instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.delete(params);
    }
  }

  onWord($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.onWord instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onWord(params);
    }
  }

  onPdf($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.onPdf instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onPdf(params);
    }
  }

  onPreview($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.onPreview instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onPreview(params);
    }
  }

  onCheckboxChange(event: any) {
    const checked = event.target.checked;

    if (this.params?.node?.data) {
      this.params.node.data.isSelected = checked;

      if (this.params.onCheckboxChange instanceof Function) {
        if (this.params.onCheckboxChange instanceof Function) {
          this.params.onCheckboxChange({
            checked: checked,
            rowData: this.params.node.data, // ✅ always send rowData
          });
        }
      }
    } else {
      console.error("params.node.data is undefined");
    }
  }
  downloadWord($event) {
    console.log(this.params);
    if (this.params.download instanceof Function) {
      console.log("hello");
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      console.log(params);
      this.params.download(params);
    }
  }

  onReview($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.onReview instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onReview(params);
    }
  }
  onStartReview($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.onStartReview instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onStartReview(params);
    }
  }
  onAssign($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.onAssign instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onAssign(params);
    }
  }
    onSignalCreation($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.onSignalCreation instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onSignalCreation(params);
    }
  }

  onDeviationCreation($event){
     console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.onDeviationCreation instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onDeviationCreation(params);
    }

  }

onLinkClick(event: MouseEvent) {
  event.stopPropagation(); //prevents row selection
}

//  SYNC CHEVRON STATE
  private syncExpandedState(): void {

    const parent = this.params.context?.componentParent;
    this.isExpanded =
      !!parent &&
      parent.expandedParentId === this.params.node.data.id;
  }

  //TOGGLE ROW FROM CHEVRON
  toggleRow(event: MouseEvent): void {
    event.stopPropagation();

    const parent = this.params.context?.componentParent;
    if (!parent) return;

    parent.onRowClicked({
      event,
      data: this.params.node.data
    });
  }

    PopUpEdit($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params.PopUpEdit instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.PopUpEdit(params);
    }
  }

    PopUpDelete($event) {
    console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params.PopUpDelete instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.PopUpDelete(params);
    }
  }

  onSignalClick(event: MouseEvent) {
  event.stopPropagation(); // prevent row selection

  if (this.params?.onSignalClick instanceof Function) {
    const params = {
      event,
      rowData: this.params.node.data
    };
    this.params.onSignalClick(params);
  }
}



  onNormalLinkClick($event) {
     console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.normalLink instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.normalLink(params);

    }
  }
  
  onRegenerateDocument($event){
     console.log("----------------");
    console.log($event);
    console.log("-------------------");
    if (this.params?.onRegenerateDocument instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onRegenerateDocument(params);
    }

  }

}
